import { render } from "./LawyersListEditModal.vue?vue&type=template&id=5b0b3384"
import script from "./LawyersListEditModal.vue?vue&type=script&lang=js"
export * from "./LawyersListEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__